import type { Skin } from "./skins";

// All token keys any skin in the catalog declares. We track them so
// `clearSkin` can fully restore defaults — setProperty('', '') leaves
// the var inheriting from globals.css (which is what we want).
const SKIN_TOKEN_KEYS = [
  "--primary-50",
  "--primary-100",
  "--primary-200",
  "--primary-300",
  "--primary-400",
  "--primary-500",
  "--primary-600",
  "--primary-700",
  "--primary-800",
  "--accent",
  "--ink-1",
  "--ink-2",
  "--ink-3",
  "--surface-bg",
  "--surface-1",
  "--surface-2",
  "--surface-2-strong",
  "--border",
  "--border-strong",
  "--radius-card",
  "--radius-btn",
  "--radius-chip",
  "--font-display",
  "--font-ui",
  "--font-num",
  "--display-weight",
  "--display-tracking",
  "--display-case",
  "--shadow-cta",
  "--cart-bg",
  "--cart-fg",
  "--hero-from",
  "--hero-to",
];

export function applySkin(skin: Skin): void {
  if (typeof document === "undefined") return;
  const root = document.documentElement;
  for (const key of SKIN_TOKEN_KEYS) {
    const value = skin.tokens[key];
    if (value !== undefined) root.style.setProperty(key, value);
    else root.style.removeProperty(key);
  }
  root.setAttribute("data-mode", skin.mode);
  root.setAttribute("data-skin", skin.id);
}

export function clearSkin(): void {
  if (typeof document === "undefined") return;
  const root = document.documentElement;
  for (const key of SKIN_TOKEN_KEYS) root.style.removeProperty(key);
  root.removeAttribute("data-mode");
  root.removeAttribute("data-skin");
}
